/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import DocsLayout from '../../components/DocsLayout';
import NextPage from '../../components/NextPage';
import BabelPlugin from '../../sections/tooling/babel-plugin.mdx';
import BabelMacro from '../../sections/tooling/babel-macro.mdx';
import TypeScriptPlugin from '../../sections/tooling/typescript-plugin.mdx';
import Jest from '../../sections/tooling/jest.mdx';
import Stylelint from '../../sections/tooling/stylelint.mdx';
import StyledTheming from '../../sections/tooling/styled-theming.mdx';
import SyntaxHighlighting from '../../sections/tooling/syntax-highlighting.mdx';
const MDXLayout = ({children}) => _jsx(DocsLayout, {
  title: "Tooling",
  description: "Additional Tools for styled-components, babel and TypeScript plugins, testing",
  children: children
});
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(BabelPlugin, {}), "\n", _jsx(BabelMacro, {}), "\n", _jsx(TypeScriptPlugin, {}), "\n", _jsx(Jest, {}), "\n", _jsx(Stylelint, {}), "\n", _jsx(StyledTheming, {}), "\n", _jsx(SyntaxHighlighting, {}), "\n", _jsx(NextPage, {
      href: "/docs/faqs",
      title: "FAQs"
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
